import * as React from 'react'
import HeadShot from './HeadShot'
import { cn } from '../../../lib/utils'

const VARIANT_STYLES = {
  mobile: {
    div: 'h-[98px] w-[98px]',
    headshot: 'h-[90px] w-[90px]',
  },
  resource: {
    div: 'h-[10rem] w-[10rem]',
    headshot: 'h-[9rem] w-[9rem]',
  },
  dashboard: {
    div: 'h-[12rem] w-[12rem] md:min-w-[12rem]',
    headshot: 'h-[11rem] w-[11rem]',
  },
  selectDashboard: {
    div: 'h-[12rem] w-[12rem] md:min-w-[12rem] p-0 border-none',
    headshot: 'h-[12rem] w-[12rem]',
  },
  default: {
    div: 'h-[12rem] w-[12rem]',
    headshot: 'h-[11rem] w-[11rem]',
  },
}

export default function HeadshotCircle({
  coachImage,
  variant = 'default', // 'mobile', 'resource', 'dashboard', or 'default'
}) {
  const styles = VARIANT_STYLES[variant] || VARIANT_STYLES.default

  return (
    <div
      className={cn(
        'relative flex items-center justify-center rounded-full border-2 border-intoo-green-coachcta bg-[#FFFFFF] shadow-md',
        styles.div,
      )}
    >
      <HeadShot
        className={cn(
          'aspect-square z-10 rounded-full object-cover',
          styles.headshot,
        )}
        coachImage={coachImage}
      />
    </div>
  )
}
